import ImageWithText from './ImageWithText';

export default ImageWithText;
